import { api } from '../index';
import apiUrls from '../../../settings/api-urls';
import { interpolate } from '../../../utilities';

export const environmentsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getEnvironments: build.query({
            query: () => ({
                url: apiUrls.ENVIRONMENTS,
                method: 'GET',
            }),
            providesTags: [ 'ENVIRONMENTS' ],
        }),
        getEnvironment: build.query({
            query: (environmentId) => ({
                url: interpolate(apiUrls.ENVIRONMENT, { environmentId }),
                method: 'GET',
            }),
            providesTags: (result, error, environmentId) => [ { type: 'ENVIRONMENTS', id: environmentId } ],
        }),
        createEnvironment: build.mutation({
            query: (body) => ({
                url: apiUrls.ENVIRONMENTS,
                method: 'POST',
                body,
            }),
            invalidatesTags: [ 'ENVIRONMENTS' ],
        }),
        updateEnvironment: build.mutation({
            query: ({ environmentId, body }) => ({
                url: interpolate(apiUrls.ENVIRONMENT, { environmentId }),
                method: 'PATCH',
                body,
            }),
            invalidatesTags: (result, error, { environmentId }) => [ 'ENVIRONMENTS', { type: 'ENVIRONMENTS', id: environmentId } ],
        }),
        deleteEnvironment: build.mutation({
            query: (environmentId) => ({
                url: interpolate(apiUrls.ENVIRONMENT, { environmentId }),
                method: 'DELETE',
            }),
            invalidatesTags: [ 'ENVIRONMENTS' ],
        }),
        getEnvironmentUsage: build.query({
            query: (environmentId) => ({
                url: interpolate(apiUrls.ENVIRONMENT_USAGE, { environmentId }),
                method: 'GET',
                silent: true,
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetEnvironmentsQuery,
    useLazyGetEnvironmentsQuery,
    useGetEnvironmentQuery,
    useLazyGetEnvironmentQuery,
    useCreateEnvironmentMutation,
    useUpdateEnvironmentMutation,
    useDeleteEnvironmentMutation,
    useGetEnvironmentUsageQuery,
    useLazyGetEnvironmentUsageQuery,
} = environmentsApi;
